var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiThemeConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.829,
    height: 65.829,
    viewBox: "0 0 65.829 65.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28835",
    "data-name": "Rectangle 28835",
    width: 65.829,
    height: 65.829,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57700",
    "data-name": "Group 57700",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159201",
    "data-name": "Path 159201",
    d: "M212.58,432.63h52.663V453.7H212.58Z",
    transform: "translate(-205.997 -410.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159202",
    "data-name": "Path 159202",
    d: "M212.246,422.633a5.266,5.266,0,0,0-5.266,5.266V462.13a5.266,5.266,0,0,0,5.266,5.266h27.648V422.633Zm3.719,24.662a2.634,2.634,0,0,1,0-4.561l11.91-6.876a2.633,2.633,0,0,1,3.95,2.281v13.752a2.633,2.633,0,0,1-3.95,2.279Z",
    transform: "translate(-206.98 -412.003)",
    fill: "#fbb945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159203",
    "data-name": "Path 159203",
    d: "M262.628,422.633H234.98V467.4h27.648a5.266,5.266,0,0,0,5.266-5.266V427.9a5.266,5.266,0,0,0-5.266-5.266ZM258.908,447.3a2.633,2.633,0,0,0,0-4.561L247,435.859a2.633,2.633,0,0,0-3.95,2.281v13.752a2.633,2.633,0,0,0,3.95,2.279Z",
    transform: "translate(-202.065 -412.003)",
    fill: "#1ad3bb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159204",
    "data-name": "Path 159204",
    d: "M232.74,420.828a2.636,2.636,0,1,1,5.266,0v49.781a2.636,2.636,0,1,1-5.266,0Z",
    transform: "translate(-202.459 -412.804)",
    fill: "#985184"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiThemeConfig);
export default __webpack_public_path__ + "static/media/uiThemeConfig.4836ff803dd66cb3405b81de835484d8.svg";
export { ForwardRef as ReactComponent };